import { render } from "./CategoryProductsFiltersModal.vue?vue&type=template&id=0b6d526b"
import script from "./CategoryProductsFiltersModal.vue?vue&type=script&lang=js"
export * from "./CategoryProductsFiltersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__